import React, { useState } from "react";
import { Box, Container } from "@mui/material";

import useDashboardRouter from "../hooks/useDashboardRouter";
import { usePermissions } from "../../../context/PermissionsContext/PermissionsContext";
import PCPDashboard from "../components/PCP/PCPDashboard";
import CEODashboard from "../components/CEO/CEODashboard";
import AdminDashboard from "../components/Admin/AdminDashboard";
import CareManagerDashboard from "../components/CareManager/CareManagerDashboard";
import BHDashboard from "../components/BehavioralHealth/BHDashboard";
import DashboardSwitcher from "../components/Admin/DashboardSwitcher";
import AiMaintenanceBanner from "../../../components/common/AiMaintenanceBanner";

/**
 * MainPage - Orquestador de dashboards por rol
 *
 * Detecta el rol del usuario y renderiza el dashboard apropiado:
 * - CEO -> Executive Dashboard
 * - Admin -> System Administration (con opción de preview de otros dashboards)
 * - Care Manager -> Care Management Dashboard
 * - Physician/otros -> Clinical Dashboard (PCP)
 */
export default function MainPage() {
  const { dashboardType } = useDashboardRouter();
  const { isAdmin } = usePermissions();
  const [previewDashboard, setPreviewDashboard] = useState(null);
  const activeDashboard = previewDashboard || dashboardType;

  const renderDashboard = () => {
    switch (activeDashboard) {
      case "ceo":
        return <CEODashboard />;
      case "admin":
        return <AdminDashboard />;
      case "care_manager":
        return <CareManagerDashboard />;
      case "behavioral_health":
        return <BHDashboard />;
      case "pcp":
      default:
        return <PCPDashboard />;
    }
  };

  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 64px)",
        py: { xs: 2, md: 3 },
        background: (theme) =>
          `linear-gradient(135deg, ${theme.palette.background.default} 0%, ${theme.palette.action.hover} 50%, ${theme.palette.background.default} 100%)`,
      }}
    >
      <Container maxWidth="xl">
        <AiMaintenanceBanner />

        {/* Admin Dashboard Switcher */}
        {isAdmin && (
          <DashboardSwitcher
            currentDashboard={activeDashboard}
            onChangeDashboard={setPreviewDashboard}
            isPreviewMode={!!previewDashboard}
          />
        )}

        {renderDashboard()}
      </Container>
    </Box>
  );
}
